import { render } from "./DevicesListClientComponent.vue?vue&type=template&id=04fa343f&scoped=true"
import script from "./DevicesListClientComponent.vue?vue&type=script&lang=js"
export * from "./DevicesListClientComponent.vue?vue&type=script&lang=js"

import "./DevicesListClientComponent.vue?vue&type=style&index=0&id=04fa343f&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fa343f"]])

export default __exports__